<template>
  <div class="content" v-loading="loading">
    <el-button
      type="primary"
      class="mw-add-button"
      @click="dialogVisible = true"
      >新建控制策略</el-button
    >
    <el-table :data="tableData">
      <el-table-column prop="title" label="名称"></el-table-column>
      <el-table-column label="策略协议">
        <template slot-scope="scope">{{
          typeArr[scope.row.type]
        }}</template>
      </el-table-column>
      <el-table-column label="策略分配">
        <template slot-scope="scope">
          <i
            class="el-icon-upload2 pointer"
            @click="openSend(scope.row)"
            title="分配控制策略"
          ></i>
        </template>
      </el-table-column>
      <el-table-column label="策略类型" v-if="light_sensitive">
        <template slot-scope="scope">{{
          strategyTypeArr[scope.row.strategy_type]
        }}</template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <i
            class="el-icon-edit pointer mar-r10"
            @click="(loading = true), openEdit(scope.row)"
          ></i>
          <i class="el-icon-delete pointer" @click="delItem(scope.row.id)"></i>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageInfo.page"
      :page-sizes="[10, 20, 30, 40, 50, 100]"
      :page-size="pageInfo.pageSize"
      layout="sizes, total, prev, pager, next, jumper"
      :total="cnt_all"
    >
    </el-pagination>

    <!-- 新增控制策略 -->
    <el-dialog
      class="big-dialog"
      title="新增控制策略"
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
    >
      <add-strategy 
        ref="addStrategy" 
        @closeMethod="closeAdd"
      ></add-strategy>
    </el-dialog>

    <el-dialog
      class="big-dialog"
      title="修改控制策略"
      :visible.sync="editVisible"
      v-if="editVisible"
    >
      <edit-strategy
        :editData="editData"
        ref="editStrategy"
        @closeMethod="closeEdit"
        @closeLoading="closeLoading"
      ></edit-strategy>
    </el-dialog>

    <el-dialog
      class="dialog800"
      :title="'策略分配['+sendData.stg_name+']'"
      :visible.sync="sendVisible"
      v-if="sendVisible"
    >
      <send-strategy
        :sendData="sendData"
        ref="sendStrategy"
        @closeMethod="closeSend"
      ></send-strategy>
    </el-dialog>
  </div>
</template>
<script>
import strategyApi from "@/api/light/strategy"
import addStrategy from "@/components/light/strategy/addStrategy.vue"
import editStrategy from "@/components/light/strategy/editStrategy.vue"
import sendStrategy from "@/components/light/strategy/sendStrategy.vue"
export default {
  components: { 
    addStrategy,
    editStrategy,
    sendStrategy
  },
  data() {
    return {
      typeArr: ['','NB-IoT','Zigbee','LoRa','Cat.1'],
      strategyTypeArr: ['普通策略','光感策略'],
      loading: false,
      tableData: [],
      pageInfo: {
        page: 1,
        pageSize: 20,
      },
      cnt_all: 0,
      dialogVisible: false,
      editVisible: false,
      editData: {
        id: null,
        type: 1,
        title: "",
        ste: null,
        uid: null,
        is_double: null,
        stg: []
      },
      sendVisible: false,
      sendData: {
        stg_id: null,
        type: 1,
        stg_name: '',
        is_double: null
      },
      light_sensitive: this.$store.state.user.account.light_sensitive
    };
  },
  methods: {
    getTableData(pageIndex) {
      this.pageInfo.page = pageIndex
      this.loading = true
      strategyApi.strategyList(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
        }
      });
    },
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },
    openSend(value) {
      let sendParams = { 
        stg_id: value.id, 
        type: value.type, 
        stg_name: value.title, 
        is_double: value.is_double
      }
      this.sendVisible = true
      this.sendData = sendParams
    },
    closeSend() {
      this.sendVisible = false
      this.sendData = {
        stg_id: null,
        type: 1,
        stg_name: '',
        is_double: null
      }
      this.getTableData(this.pageInfo.page);
    },
    closeAdd() {
      this.dialogVisible = false
      this.getTableData(this.pageInfo.page);
    },
    openEdit(strategy) {
      if(strategy.stg.length<25){
        this.editVisible = true
        this.editData = strategy
      }else{ // 防止数据量太长 浏览器加载卡死现象
        setTimeout(() => {
          this.editVisible = true
          this.editData = strategy
        }, 800)
      }
    },
    closeEdit() {
      this.editVisible = false
      this.editData = {
        id: null,
        title: "",
        type: 1,
        ste: null,
        uid: null,
        is_double: null,
        stg: []
      }
      this.getTableData(this.pageInfo.page);
    },
    closeLoading(){
      this.loading = false
    },
    delItem(id) {
      this.$confirm("本操作将永久删除该条信息，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          strategyApi.strategyDel(id).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success("删除成功");
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    getValue(value) {
      if (value == "1") {
        return "双灯模式";
      } else {
        return "单灯模式";
      }
    }
  },
  mounted() {
    this.getTableData(this.pageInfo.page)
  },
};
</script>

<style scoped>
.new-strategy {
  display: inline-block;
  margin-top: 20px;
}
.pointer {
  cursor: pointer;
}
.lamp-refresh {
  top: -10px;
}
</style>
